import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, Drawer, Input, message, Select } from "antd";
import React, { useState } from "react";
import {
  Form,
  redirect,
  useActionData,
  useLoaderData,
  useNavigate,
} from "react-router-dom";
import { changeUserPassword, getUserDetails, updateUser } from "../../api/user";
import ProfileUpload from "../../components/inputs/ProfilePhoto.jsx";
import { ValidationError } from "../../library/classes/exceptions/index.js";
import { VendorUserRoles } from "../../library/constants/VendorUserRoles.js";
import {
  getFieldErrors,
  getFieldStatus,
} from "../../library/helpers/forms/index.js";
import Styles from "./user-details.module.scss";

const VendorUserDetails = () => {
  const { user } = useLoaderData();
  const navigate = useNavigate();
  const { errors = null } = useActionData() || {};
  const [userType, setUserType] = useState(user.roles);

  return (
    <Drawer
      open={true}
      mask={false}
      title={`User: ${user.name}`}
      onClose={() =>
        navigate("..", {
          replace: true,
          relative: "route",
          preventScrollReset: true,
        })
      }
    >
      <div style={{ marginBottom: "1.5rem" }}>
        <ProfileUpload user={user} />
      </div>
      <Form method="post" key={`${user.id}-${user.name}`} className={Styles.formWrapper}>
        <div className={Styles.fieldsRow}>
          <div className={Styles.inputField}>
            <label>First Name</label>
            <Input
              type="text"
              name="first_name"
              key={user.first_name}
              defaultValue={user.first_name}
              required
              status={getFieldStatus("first_name", errors)}
            />
            {getFieldErrors("first_name", errors)}
          </div>
          <div className={Styles.inputField}>
            <label>Last Name</label>
            <Input
              type="text"
              name="last_name"
              key={user.last_name}
              defaultValue={user.last_name}
              status={getFieldStatus("last_name", errors)}
            />
            {getFieldErrors("last_name", errors)}
          </div>
        </div>
        <div className={Styles.fieldsWrapper}>
          <div className={Styles.inputField}>
            <label>Email</label>
            <Input
              type="email"
              name="email"
              key={user.email}
              defaultValue={user.email}
              required
              status={getFieldStatus("email", errors)}
            />
            {getFieldErrors("email", errors)}
          </div>
        </div>
        {/* <div className={Styles.fieldsWrapper}>
                    <div className={Styles.inputField}>
                        <label>Username</label>
                        <Input type="text" name="username" key={user.username} defaultValue={user.username} required status={getFieldStatus('username', errors)} />
                        {getFieldErrors('username', errors)}
                    </div>
                </div> */}
        <div className={Styles.fieldsWrapper}>
          <div className={Styles.inputField}>
            <label>Roles</label>
            <Select
              key={user.roles}
              options={VendorUserRoles}
              mode="multiple"
              fieldNames={{ value: "id", label: "name" }}
              defaultValue={user.roles}
              onChange={(c) => {
                setUserType(c);
              }}
              status={getFieldStatus("user_roles", errors)}
              getPopupContainer={(triggerNode) => triggerNode.parentElement}
            />
            {getFieldErrors("user_roles", errors)}
            <input type="hidden" name="roles" value={userType.join(",")} />
          </div>
        </div>
        <Button
          type="primary"
          name="action"
          value="updateUser"
          htmlType="submit"
        >
          Update
        </Button>
      </Form>
      <br />
      <Form method="post" className={Styles.formWrapper}>
        <div className={Styles.fieldsWrapper}>
          <div className={Styles.inputField}>
            <label>New Password</label>
            <Input.Password
              placeholder="New Password"
              name="newpassword"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              status={getFieldStatus("name", errors)}
              pattern="^(?=.*[0-9])(?=.*[\W_])(?=.*[a-zA-Z])(?=\S+$).{6,}$"
              title="Password must contain at least one digit, one special character, one letter, and be at least 6 characters."
              required
            />
            {getFieldErrors("name", errors)}
          </div>
        </div>
        <Button
          type="primary"
          name="action"
          value="resetPassword"
          htmlType="submit"
        >
          Reset Password
        </Button>
      </Form>
    </Drawer>
  );
};

VendorUserDetails.Actions = {
  // updateProfilePhoto: async ({ params, data }) => {
  //     const { uId } = params
  //     const payload = data;
  //     try {
  //         //Todo: Basic validation
  //         const { message: msg, data } = await updateUser(uId, payload)
  //         message.success(msg)
  //         return data
  //     }
  //     catch (error) {
  //         message.error(error.message)
  //         if (error instanceof ValidationError) {
  //             return {
  //                 errors: error.errors
  //             }
  //         }
  //     }
  //     return false
  // },
  updateUser: async ({ params, data, request }) => {
    const { uId } = params;
    const { first_name, last_name, email, roles } = data;
    try {
      await updateUser(uId, {
        first_name,
        last_name,
        email,
        user_roles: roles.split(",").filter(Boolean),
      });
      message.success("User Update!");
      const url = new URL(request.url);
      return redirect(url.pathname + url.search);
    } catch (error) {
      message.error(error.message);
      if (error instanceof ValidationError) {
        return {
          errors: error.errors,
        };
      }
    }
    return false;
  },
  resetPassword: async ({ params, data }) => {
    const { uId } = params;
    const { newpassword } = data;

    try {
      const msg = await changeUserPassword(uId, newpassword);
      message.success(msg);
      return true;
    } catch (error) {
      if (error instanceof ValidationError) {
        return {
          errors: error.errors,
        };
      }
    }
    return false;
  },
};

VendorUserDetails.Loader = async ({ params }) => {
  const { uId } = params;
  const user = await getUserDetails(uId);
  return { user };
};

export default VendorUserDetails;
